







































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import HolidaysBookingDetails from "../holidays/HolidaysBookingDetails.vue";

import HolidayProgramJson from "../../shared/HolidayProgramJson";
import { HolidayProgramWithBookingJson } from "../../shared/HolidayProgramJson";
import HolidayProgramBookingJson from "../../shared/HolidayProgramBookingJson";
import { HolidayProgramBookingStatus } from "../../shared/HolidayProgramBookingStatus";
import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType } from "../../shared/PaymentExportType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";

export default Vue.extend({
  name: "HolidaysPayments",
  components: {
    Loading,
    HolidaysBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
    HolidayProgramBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      HolidayProgramBookingStatus: HolidayProgramBookingStatus,
      paymentExportHolidays: null as HolidayProgramWithBookingJson[] | null,
      exportedHolidays: null as PaymentExportInfoJson[] | null,
      selectedHolidayProgramId: null as number | null,
      selectedHolidayBookingId: null as number | null,
      detailsMode: "read",
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    openDetails(item: HolidayProgramWithBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedHolidayProgramId = item.ID;
        this.selectedHolidayBookingId = item.booking.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadHolidaysToExport();
      this.loadExportedHolidays();
    },

    async loadHolidaysToExport() {
      this.paymentExportHolidays = null;
      if (this.restClient != null) {
        try {
          this.paymentExportHolidays = await this.restClient.getHolidayProgramBookingsReadyForPaymentExport();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadExportedHolidays() {
      this.exportedHolidays = null;
      if (this.restClient != null) {
        try {
          this.exportedHolidays = await this.restClient.getRecentPaymentExports(
            PaymentExportType.holidayProgramBookings
          );
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //export payment data
    async exportPaymentData() {
      this.isExporting = true;

      try {
        var exportInfo = await this.restClient.exportPaymentsForHolidayProgramBookings();
        if (exportInfo != null) {
          this.downloadPaymentData(exportInfo);
        } else {
          this.isExporting = false;
          alert("Aktuell sind keine Zahlungsdaten zum Export bereit.");
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    async downloadPaymentData(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
